"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventEmitter = void 0;
function eventEmitter() {
    var events = {};
    return {
        /**
         * Registers a new listener
         */
        addListener: function (channel, listener) {
            if (!events[channel]) {
                events[channel] = [];
            }
            events[channel].push(listener);
        },
        /**
         * Broadcasts an event to all active listeners on a channel
         */
        emit: function (channel, data) {
            if (!events[channel]) {
                return;
            }
            events[channel].forEach(function (cb) { return cb(data); });
        },
        /**
         * Removes a listener
         */
        removeListener: function (channel, listener) {
            if (!events[channel]) {
                return;
            }
            events[channel] = events[channel].filter(function (l) { return l !== listener; });
        }
    };
}
exports.eventEmitter = eventEmitter;
//# sourceMappingURL=event-emitter.js.map